import { Megaphone } from "lucide-react";
import { useSiteSettings } from "@/context/SiteSettingsContext";

export const MARQUEE_DURATION = { slow: "34s", normal: "22s", fast: "12s" };

export const MarqueeStrip = ({ text, speed, testid = "home-marquee" }) => (
  <div className="jp-marquee relative flex items-center overflow-hidden border-y border-[#e5b80b]/30 bg-[#0b0a07] py-2" data-testid={testid}>
    <span className="relative z-10 flex shrink-0 items-center gap-1 bg-[#0b0a07] pl-3 pr-2 text-[#e5b80b]">
      <Megaphone size={14} />
    </span>
    <div className="overflow-hidden">
      <div className="jp-marquee-track" style={{ "--jp-marquee-dur": MARQUEE_DURATION[speed] || "22s" }}>
        {[0, 1].map((i) => (
          <span key={i} className="kz-display px-8 text-xs tracking-wide text-[#f3c74b] sm:text-sm" aria-hidden={i === 1}>
            {text}
          </span>
        ))}
      </div>
    </div>
  </div>
);

export const HomeMarquee = () => {
  const { marquee_enabled, marquee_text, marquee_speed } = useSiteSettings();
  if (!marquee_enabled || !marquee_text) return null;
  return <MarqueeStrip text={marquee_text} speed={marquee_speed} />;
};
